















import { Component, Vue, Prop } from 'vue-property-decorator'

import { BButton, BModal, BIconCartCheck } from 'bootstrap-vue'

@Component({
  components: { BButton, BModal, BIconCartCheck }
})
export default class CheckoutButton extends Vue {
  @Prop({ required: false, default: false })
  private disabled!: boolean

  @Prop({ required: false, default: false })
  private padded!: boolean
}
